<!--bel pl heeft Samenwerkingsverband & invullen cijfers op samenwerkingsniveau-->
<div *ngIf="heeftSamenwerkingsverband() && heeftOndernemingen() && !heeftInvullenOpPersoonlijkNiveau()">

    <form [formGroup]="ondernemingFG">
        <div formArrayName="ondernemingen">
            <div *ngFor="let onderneming of ondernemingen.controls; let i = index" [formGroupName]="i"
                 class="mb-1">

                <div formGroupName="resultaatSamenwerking">

                    <div *ngIf="isDefAangifte">

                        <p><b>Kapitaalaandeel </b></p>

                        <snelstart-ui-number-form-control
                                (change)="saveForm()"
                                [decimals]="0"
                                align="right"
                                class="custom-input-200"
                                formControlName="aandeelBelastingplichtigeInKapitaalVolgensContract"
                                id="aandeelKapitaalContract-{{i}}"
                                label="Aandeel in eindvermogen"
                                prefix="€"
                        >
                        </snelstart-ui-number-form-control>


                        <snelstart-ui-number-form-control
                                (change)="saveForm()"
                                [decimals]="0"
                                align="right"
                                class="custom-input-200"
                                formControlName="aandeelBelastingplichtigeInBeginVermogen"
                                id="aandeelKapitaalOverig-{{i}}"
                                label="Aandeel in beginvermogen"
                                prefix="€"
                        >
                        </snelstart-ui-number-form-control>

                        <div class="pb-2"></div>
                    </div>

                    <p><b>Winstaandeel</b></p>

                    <snelstart-ui-number-form-control
                            (change)="saveForm(); updateTotaalResultaat(i)"
                            [decimals]="0"
                            align="right"
                            class="custom-input-200"
                            formControlName="vergoedingVoorArbeidBelastingplichtige"
                            id="aandeelKapitaalOverig-{{i}}"
                            label="Vergoeding voor arbeid"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm(); updateTotaalResultaat(i)"
                            [decimals]="0"
                            align="right"
                            class="custom-input-200"
                            formControlName="overigeVergoedingenBelastingplichtige"
                            id="aandeelKapitaalOverig-{{i}}"
                            label="Overige vergoedingen"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm(); updateTotaalResultaat(i)"
                            [decimals]="0"
                            align="right"
                            class="custom-input-200"
                            formControlName="aandeelRestantWinstBelastingplichtige"
                            id="aandeelKapitaalOverig-{{i}}"
                            label="Aandeel in restant winst"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            class="custom-input-200"
                            formControlName="totaalResultaat"
                            id="totaalResultaat-{{i}}"
                            label="Totaal winstaandeel"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>


                </div>

            </div>
        </div>
    </form>

</div>


<!--bel pl heeft wel Samenwerkingsverband & invullen cijfers op persoonlijk niveau-->
<div *ngIf="heeftSamenwerkingsverband() && heeftOndernemingen() && heeftInvullenOpPersoonlijkNiveau()">
    <div *ngIf="!partnerBoolean">
        Er is voor {{ this.dataService.naamAangever }} sprake van het invullen van de cijfers op persoonlijk niveau.
    </div>

    <div *ngIf="partnerBoolean">
        Er is voor {{ this.dataService.naamPartner }} sprake van het invullen van de cijfers op persoonlijk niveau.
    </div>
</div>

<!--bel pl heeft wel Samenwerkingsverband & invullen cijfers op persoonlijk niveau-->
<div *ngIf="!heeftSamenwerkingsverband() && heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is voor {{ this.dataService.naamAangever }} geen sprake van een samenwerkingsverband.
    </div>

    <div *ngIf="partnerBoolean">
        Er is voor {{ this.dataService.naamPartner }} geen sprake van een samenwerkingsverband.
    </div>
</div>


<!--bel pl heeft geen onderneming-->
<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
